export default "__VITE_ASSET__DeFbiiNF__"